<template>
  <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 museo-sans-normal">
    <div class="bg-white p-6 rounded-md shadow-md w-1/3">
      <div class="flex justify-between pb-2">
        <h1 class="font-bold text-3xl text-center mb-5">Billing Information</h1>
        <button class="text-black font-bold rounded-full border border-s-gray-200 p-1 w-8 h-8 cursor-pointer" @click="$emit('close')">x</button>
      </div>
      <h2 class="text-xl font-bold mb-4">Payment Method</h2>
      <div class="flex w-full flex-col p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100">
        <div class="flex w-full">
          <h5 class="font-bold mr-auto">Mpesa</h5>
          <svg class="ml-auto" width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect width="30" height="21.9847" fill="url(#pattern0_8173_56145)"/>
            <defs>
              <pattern id="pattern0_8173_56145" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_8173_56145" transform="scale(0.00381679 0.00520833)"/>
              </pattern>
              <image id="image0_8173_56145" width="262" height="192" preserveAspectRatio="none"
                     xlink:href="data:image/png;base64,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"/>
            </defs>
          </svg>
        </div>
        <p class="mt-5">
          You can pay a minimum of 80% of the accumulated bill amount of KES {{ props.amount }}. Please ensure you have
          enough money to complete the payment.
        </p>
        <h5 class="font-bold mt-4 text-sm">Amount (KES)</h5>
        <div class="max-w-xl mt-3">
          <input
            v-model.number="paymentAmount"
            type="number"
            step="0.01"
            min="0"
            class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            :class="{ 'border-red-500': amountError }"
            @input="validateAmount"
            required
          />
          <p v-if="amountError" class="text-red-500 text-sm mt-1">{{ amountError }}</p>
        </div>
        <h5 class="font-bold mt-4 text-sm">Mpesa Number</h5>
        <div class="max-w-xl mt-3">
          <div class="flex items-center">
            <div
              class="shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100"
            >
              +254
            </div>
            <div class="relative w-full">
              <input
                v-model="phoneNumber"
                type="text"
                id="phone-input"
                class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                placeholder="e.g 712 xxx xxx"
                required
              />
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center mt-4 gap-2">
          <button
            @click="proceedToPayment"
            class="px-10 py-2 rounded-md"
            :class="promptingPayment ? 'bg-gray-200 text-black border-custom-blue' : 'bg-custom-blue text-white'"
            :disabled="promptingPayment || !!amountError"
          >
            {{ initialPromptSent ? (promptingPayment ? 'Resending prompt...' : 'Resend Prompt') : (promptingPayment ? 'Sending prompt...' : 'Send Prompt') }}
          </button>
          <button
            v-if="initialPromptSent"
            class="text-white bg-green-600 py-2 px-4"
            @click.prevent="confirmPayment"
            :disabled="confirmingPayment"
          >
            {{ confirmingPayment ? 'Confirming ...' : 'Confirm Payment' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, defineProps } from 'vue';
import apiClient from "@/services/api";
import { useToast } from "vue-toast-notification";

const props = defineProps({
  amount: Number,
  show: Boolean,
  facilityId: String,
});

const toast = useToast({
  position: 'top-right',
  duration: 3000,
  dismissible: true,
  pauseOnHover: true,
  type: 'default',
});

const promptingPayment = ref(false);
const initialPromptSent = ref(false);
const confirmingPayment = ref(false);
const phoneNumber = ref('');
const paymentAmount = ref(props.amount || 0);
const amountError = ref('');

const minimumAmount = computed(() => {
  const min = (props.amount * 0.8) || 0;
  return min.toFixed(2);
});

const showModal = computed(() => props.show);

const formatKenyanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return 'N/A';
  let cleaned = phoneNumber.toString().replace(/\D/g, '');
  if (cleaned.startsWith('0')) {
    cleaned = '254' + cleaned.slice(1);
  } else if (cleaned.startsWith('+254')) {
    cleaned = cleaned.slice(1);
  } else if (cleaned.length === 9 && /^[0-1][0-9]{8}$/.test(cleaned)) {
    cleaned = '254' + cleaned;
  } else if (cleaned.length === 9) {
    cleaned = '254' + cleaned;
  } else {
    return 'Invalid number';
  }
  if (cleaned.length !== 12) {
    return 'Invalid number';
  }
  return cleaned;
};

const validateAmount = () => {
  console.log('Validating amount:', paymentAmount.value, 'Minimum:', props.amount * 0.8);
  const minAmount = props.amount * 0.8;
  if (paymentAmount.value < minAmount) {
    amountError.value = `Payable amount must be at least KES ${minimumAmount.value}`;
  } else if (paymentAmount.value <= 0) {
    amountError.value = 'Payable amount must be greater than KES 0';
  } else {
    amountError.value = '';
  }
  console.log('Amount error:', amountError.value);
};

const proceedToPayment = async () => {
  if (!phoneNumber.value) {
    toast.error('Please enter a valid phone number.');
    return;
  }
  if (!props.facilityId) {
    toast.error('Facility ID required.');
    return;
  }
  validateAmount();
  if (amountError.value) {
    toast.error(amountError.value);
    return;
  }
  try {
    promptingPayment.value = true;
    const formattedPhoneNumber = formatKenyanPhoneNumber(phoneNumber.value);
    if (formattedPhoneNumber === 'Invalid number') {
      promptingPayment.value = false;
      toast.error('Please enter a valid Kenyan phone number.');
      return;
    }
    const response = await apiClient.initiatePaymentStkPush({
      amount: paymentAmount.value,
      phoneNumber: formattedPhoneNumber,
      facility_id: props.facilityId
    });
    if (response.success) {
      toast.success("Payment prompt sent successfully. Please check your phone.");
      setTimeout(() => {
        promptingPayment.value = false;
        initialPromptSent.value = true;
        phoneNumber.value = '';
      }, 3000);
    } else {
      promptingPayment.value = false;
      toast.error(response.message || 'Failed to initiate payment 1');
    }
  } catch (e) {
    promptingPayment.value = false;
    toast.error('Failed to initiate payment 2');
    console.error("Failed to initiate payment:", e);
  }
};

const confirmPayment = async () => {
  try {
    confirmingPayment.value = true;
    const response = await apiClient.confirmBillPaymentStatus(props.facilityId);
    if (response.success) {
      toast.success("Payment received successfully.");
      window.location.reload();
    } else {
      toast.error('Payment not yet received.');
    }
    confirmingPayment.value = false;
  } catch (e) {
    confirmingPayment.value = false;
    toast.error("Failed to confirm payment");
    console.error("Failed to confirm payment:", e);
  }
};

// Validate amount on mount and when amount prop changes
watch(
  () => props.amount,
  () => {
    paymentAmount.value = props.amount || 0;
    validateAmount();
  },
  { immediate: true }
);
</script>

<style scoped>
</style>